const React = require('react');
const classNames = require('classnames');
const TileShine = require('./tile-shine');

module.exports = ({ url, children, onClick, theme, shine, isNewTab = false }) => {
    const renderShine = shine === false ? null : <TileShine />;

    return (
        <a className={classNames('c-tile__link', theme)}
            href={url}
            onClick={onClick}
            {...(isNewTab && { target: '_blank' })}>
            { children }
            { renderShine }
        </a>
    );
};
